<template>
  <div class="col-sm-12 text-center container">
    <div class="level">
      <div class="star-container">
        <div v-for="(i, index) in 3" :key="index">
          <b-icon
            :class="{
              'top-star': index === 1,
              one: rating === 1 && index === 0,
              two: rating === 2 && index < 2,
              three: rating === 3 && index < 3,
            }"
            icon="star-fill"
          ></b-icon>
        </div>
      </div>
      <div class="title-content">
        <tuuz-right class="tuuz-r"> </tuuz-right>
        <div class="level-title"><span>БАЯР ХҮРГЭЕ</span></div>
        <tuuz-left class="tuuz-l"> </tuuz-left>
      </div>

      <div class="level-body">
        <div class="row-data">
          <b-col>Оноо:</b-col>
          <b-col>{{ levelresult.score }}</b-col>
        </div>

        <div class="row-data">
          <b-col>Хувь:</b-col>
          <b-col>{{ levelresult.percent }}%</b-col>
        </div>

        <div class="row-data">
          <b-col>Оролдлого:</b-col>
          <b-col>{{ levelresult.tryCounter }}</b-col>
        </div>

        <div class="row-data">
          <b-col>Хугацаа:</b-col>
          <b-col>{{ spendlevel }}</b-col>
        </div>
      </div>
      <b-button v-if="isTask" :to="{name: 'LevelStage'}" variant="warning">ДАРААГИЙН ҮЕ</b-button>
      <b-button v-if="!isTask" to="/Registration" class="btn btn-warning"
        >БҮРТГҮҮЛЭХ</b-button
      >
    </div>
  </div>
</template>

<script>
import TuuzRight from "./icons/TuuzRight.vue";
import TuuzLeft from "./icons/TuuzLeft.vue";
import user from "../mixins/user";
import OwnerService from "../api-services/owner.service.js";

export default {
  props: ["levelresult"],
  mixins: [user],
  components: {
    TuuzRight,
    TuuzLeft,
  },
  data: () => {
    return {
      angiId: -1,
      bagtsId: -1,
      levelId: -1,
      categoryId: 0,
      spendlevel: null,
      isTask: false,
      rating: null,
    };
  },
  methods: {
    time(ms) {
      var seconds = Math.floor((ms / 1000) % 60);
      var minutes = Math.floor((ms / (60 * 1000)) % 60);
      var hours = Math.floor((ms / (60 * 60 * 1000)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (hours === "00") {
        hours = "";
      } else {
        hours = hours + "цаг";
      }
      if (minutes === "00") {
        minutes = "";
      } else {
        minutes = minutes + "мин";
      }

      return hours + " " + minutes + " " + seconds + "ceк";
    },

    calcrating(score, counter) {
      let rating;
      if (score > 89) {
        if (counter < 5) {
          rating = 3;
        } else if (counter > 5) {
          rating = 2;
        } else if (counter > 10) {
          rating = 1;
        }
      } else if (score > 59) {
        if (counter < 5) {
          rating = 2;
        } else if (counter > 5) {
          rating = 1;
        } else if (counter > 10) {
          rating = 0;
        }
      } else if (score > 29) {
        if (counter < 5) {
          rating = 1;
        } else if (counter > 5) {
          rating = 0;
        }
      } else {
        rating = 0;
      }
      return rating;
    },
    async sendLevel() {
      try {
        const that = this;
        const resp = await OwnerService.endLevel({
          angi: this.angiId,
          bagts: this.bagtsId,
          level: this.levelId,
          score: that.levelresult.score,
          point: that.levelresult.point,
          duration: that.levelresult.duration,
          try_count: that.levelresult.tryCounter
        });
        console.log(resp.data);
      } catch (ex) {
        console.log(ex);
      }
    },
  },

  async mounted() {
    if (this.$route.name !== "TaskDemo") {
      this.isTask = true;
    }
    this.spendlevel = this.time(this.levelresult.duration);

    this.rating = this.calcrating(
      this.levelresult.percent,
      this.levelresult.tryCounter
    );
    this.levelresult.point = this.rating;

    this.categoryId = localStorage.getItem("category");
    this.angiId = localStorage.getItem("angi");
    this.bagtsId = localStorage.getItem("bagts");
    this.levelId = localStorage.getItem("level");

    if (this.isTask) {
      await this.sendLevel();
    }
  },
};
</script>

<style scoped>
.container {
  padding: 170px 50px 50px 50px;
}
.level {
  border: 1px solid #707070;
  max-width: 497px;
  margin: 0 auto 0 auto;
  position: relative;
  padding: 0px 0px 50px 0px;
  border-radius: 1.25em;
  background-color: #fff;
}
.title-content {
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.star-head-content {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.level-title {
  font-family: "Balsamiq Sans", "Roboto", cursive;
  font-style: italic;
  min-width: 536px;
  height: 95px;
  background-color: #f9850c;
  border: 1px solid #872709;
  font-size: 3.125em;
  color: #ffffff;
  display: flex;
  align-items: center;
  z-index: 10;
  margin-top: -10px;
}
.level-title > span {
  width: 100%;
}
.tuuz-l {
  z-index: 1;
  margin-left: -20px;
}

.tuuz-r {
  z-index: 1;
  margin-right: -20px;
}
.content {
  border: 1px solid #b6887b;
  background-color: #fff;
  margin: 0 auto 0 auto;
  padding: 80px 0 50px 0;
  border-radius: 1.25em;
}
.level-body {
  padding: 110px 0px 50px 0px;
  max-width: 300px;
  margin: 0 auto 0 auto;
}
.row-data {
  text-align: start;
  display: flex;
  justify-content: space-between;
  color: #000000;
  font-size: 1.125em;
  font-weight: 550;
  margin-top: 5px;
}

.btn {
  background-color: #f9850c;
  color: #fff;
  font-size: 1.1em;
  border: none;
}
.star-container {
  display: flex;
  justify-content: center;
  margin-top: -110px;
  font-size: 8em;
  color: white;
  stroke: #f9850c;
}
.top-star {
  margin-bottom: 30px;
}
.one {
  color: red;
}
.two {
  color: red;
}
.three {
  color: red;
}
</style>
